module.exports = __webpack_public_path__ + "static/media/IconLightning.e67994e3.svg";